import WidgetInvoicing from './WidgetInvoicing';

export default WidgetInvoicing;
